
import { EventSubscriber } from 'apprise-frontend-events/subscriptions';
import { useCategoryLifecycleListener } from 'apprise-frontend-tags/category/events';
import { useTagLifecycleListener } from 'apprise-frontend-tags/tag/events';


// registers actions and listens for events, so doesn't need to wrap around children for now.

export const TagInitializer = () => {

    const categorylifecycleListener = useCategoryLifecycleListener()
    const taglifecycleListener = useTagLifecycleListener()

    return <EventSubscriber name='category-lifecycle-listener' subscriptions={[categorylifecycleListener,taglifecycleListener]} />
 
}